import { Hero, Bio, Interests, Stats, SocialEmbed, ContactCTA } from '@ui/sections';
import { site } from '@content/site';
import { socialEmbedCopy, contactCtaCopy } from '@content/ui-strings';

export function HomeRoute() {
  return (
    <>
      <Hero hero={site.hero} links={site.links} />
      <Stats items={site.stats} />
      <Bio bio={site.bio} eras={site.eras} />
      <Interests interests={site.interests} />
      <SocialEmbed
        xHandle={site.links['xhandle'] ?? ''}
        xHref={site.links['x'] ?? '#'}
        linkedinHref={site.links['linkedin'] ?? '#'}
        copy={socialEmbedCopy}
      />
      <ContactCTA calendlyHref={site.links['calendly'] ?? '#'} copy={contactCtaCopy} />
    </>
  );
}
